import api from '../api';

import { ParamsBodyByZipCode } from 'utils/typeServices';

export const GetByZipCode = async ({ token, cep }: { token: string, cep: string }) => {
    try {
        const { data } = await api.get<{ Data: ParamsBodyByZipCode }>(`/v1/Cliente/GetByZipCode/${cep}`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return {
            data: {
                cep: cep,
                cityId: data.Data.cityId,
                cityName: data.Data.cityName,
                district: data.Data.district,
                fullAddress: data.Data.fullAddress,
                isGeneralZip: data.Data.isGeneralZip,
                shortAddress: data.Data.shortAddress,
                stateName: data.Data.stateName,
                type: data.Data.type,
            }
        };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
